<template>
  <el-container class="roleBody">
    <el-aside width="200px">
      <el-col>
        <div style="justify-content: space-between; display: flex">
          <div style="display: flex; align-items: center">角色列表</div>
          <el-button type="primary" @click="addRole()">新增角色</el-button>
        </div>

        <el-col>
          <el-menu
            :default-openeds="['1', '2']"
            text-color="#000"
            :default-active="menuDefaultActive"
          >
            <el-submenu index="1">
              <template slot="title">系统默认角色</template>

              <el-menu-item
                v-for="(item, index) in roleListDefault"
                :index="1 + String(index)"
                :key="index"
                class="row-item"
                @click="leftMenuCheck(item, false)"
              >
                <el-col>
                  <div
                    @mouseover="showIcon(index, 1)"
                    @mouseleave="hideIcon(index, 1)"
                    class="hover-text"
                  >
                    {{ item.name }}
                    <i
                      v-show="isIconVisibleDefault[index]"
                      class="el-icon-delete"
                    />
                  </div>
                </el-col>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">自定义角色</template>

              <el-menu-item
                v-for="(item, index) in roleListNoDefault"
                :index="2 + String(index)"
                :key="index"
                class="row-item"
                @click="leftMenuCheck(item, true)"
              >
                <el-col>
                  <div
                    @mouseover="showIcon(index, 2)"
                    @mouseleave="hideIcon(index, 2)"
                    class="hover-text"
                  >
                    {{ item.name }}
                    <i
                      v-show="isIconVisibleNoDefault[index]"
                      class="el-icon-delete"
                      @click="delRole(item)"
                    />
                  </div>
                </el-col>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-col>
    </el-aside>

    <el-container>
      <el-main>
        <div
          v-if="leftMenuCheckRole !== null"
          style="height: 100%; width: 100%"
        >
          角色信息
          <div
            style="
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 10px;
              margin-top: 10px;
            "
          >
            <el-form
              ref="leftMenuCheckRole"
              label-width="auto"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 0;
              "
            >
              <div prop="roleName" style="display: flex; align-items: center">
                <el-input
                  v-model="leftMenuCheckRole.name"
                  @blur="rightRoleFocusOutEvent()"
                  :disabled="!leftMenuCheckRoleChangeFlag"
                  style="margin-right: 20px"
                />

                <i
                  v-if="rightRoleFocusStatus"
                  :class="
                    rightRoleFocusIconStatus === 0
                      ? 'el-icon-loading'
                      : 'el-icon-check'
                  "
                  style="color: #42b983; height: fit-content"
                />
              </div>
            </el-form>
            <el-button type="primary" @click="openPermissionSettings()"
              >权限配置</el-button
            >
          </div>
          角色成员
          <div
            style="
              width: 100%;
              height: max-content;
              margin-bottom: 10px;
              margin-top: 10px;
            "
          >
            <div style="height: auto">
              <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <el-button type="primary" @click="addPeople()"
                  >新增成员</el-button
                >

                <el-form label-width="auto" style="">
                  <el-form-item
                    prop="roleName"
                    style="
                      display: flex;
                      margin: 0;
                      flex-direction: column;
                      align-content: center;
                    "
                  >
                    <el-input
                      @blur=""
                      v-model="queryEmployeeIDORNameForm.keyWord"
                      style="width: 200px; margin-right: 10px"
                      placeholder="请输入人员编号或姓名"
                    ></el-input>
                    <el-button type="primary" @click="queryEmployeeIDORName()"
                      >查询</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>

          <div class="tableContainer">
            <el-table
              v-loading="listLoading"
              :data="dataList"
              border
              fit
              highlight-current-row
            >
              <el-table-column
                label="序号"
                prop="employeeId"
                align="center"
                width="100"
              />
              <el-table-column
                label="人员姓名"
                prop="employeeName"
                width="200"
                align="center"
              />
              <el-table-column
                label="电话号码"
                prop="phone"
                width="200"
                align="center"
              />
              <el-table-column
                label="性别"
                prop="sex"
                width="100"
                align="center"
              />
              <el-table-column
                label="所在部门"
                prop="deptName"
                width="200"
                align="center"
              />

              <el-table-column
                label="操作"
                prop="tpye"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="delEmployeeRole(scope.row)"
                    >移除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <!--页码-->
            <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="queryForm.current"
              :limit.sync="queryForm.size"
              @pagination="getAccountManageMore"
            />
          </div>
        </div>
      </el-main>
    </el-container>

    <!--删除弹窗-->
    <el-dialog
      title="删除"
      :visible.sync="delInfoDialogVisibleFlag"
      width="30%"
    >
      <span>确定删除 {{ delInfo.name }} 角色 ？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delInfoSubmit()">确 定</el-button>
        <el-button @click="delInfoDialogVisibleFlag = false">取 消</el-button>
      </span>
    </el-dialog>

    <!--  新增角色  -->
    <el-dialog
      title="新增角色"
      :visible.sync="addRoleDialogVisibleFlag"
      :close-on-click-modal="false"
    >
      <el-form :model="addRoleForm" ref="addRoleForm" label-width="120px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input
            v-model="addRoleForm.roleName"
            maxlength="10"
            @blur="roleBlueEvent()"
            placeholder="只限中文，10个汉字"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        style="
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button type="primary" @click="addRoleSubmitForm()">确 定</el-button>
        <el-button @click="cancelDialog()">取消</el-button>
      </div>
    </el-dialog>

    <!-- 新增成员 -->
    <add-people
      :addPeopleVisible="addPeopleVisible"
      :dialogTitle="dialogTitle"
      :peopleList="selectPeopleList"
      @closeAddPeopleVisible="closeAddPeople"
      @submitPeople="submitPeople"
    ></add-people>

    <!-- 权限配置 -->
    <el-dialog
      title="权限配置"
      :visible.sync="permissionSettingsDialogVisibleFlag"
      width="60%"
      height="80%"
      :close-on-click-modal="false"
    >
      <el-row type="flex" justify="space-between" style="margin-bottom: 20px">
        <el-col class="autoTxt1">
          配置“{{
            leftMenuCheckRole != null ? leftMenuCheckRole.name : ""
          }}”相关权限
        </el-col>
        <el-col class="autoTxt1">
          已选 {{ treeSelectedCount }} 项功能
          <el-checkbox v-model="treeShowChecked" @change="showTreeNodeChange"
            >只看已选</el-checkbox
          >
        </el-col>
      </el-row>

      <el-divider />

      <el-tabs tab-position="left" style="max-height: 350px; overflow: auto">
        <el-tab-pane
          v-for="(item, index) in listRoleMenu"
          :key="index"
          :label="item.menuTypeName"
        >
          <el-tree
            :data="item.menuList"
            show-checkbox
            default-expand-all
            node-key="menuId"
            ref="tree"
            highlight-current
            :props="defaultProps"
            @check="handleNodeClick"
            :filter-node-method="filterNode"
          >
          </el-tree>
        </el-tab-pane>
      </el-tabs>

      <div
        style="
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button type="primary" @click="saveRoleMenu()">确定</el-button>
        <el-button @click="roleMenuReset()">恢复默认</el-button>
        <el-button @click="permissionSettingsDialogVisibleFlag = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </el-container>
</template>

<style>
.roleBody {
  width: 100%;
  height: 100%;
  padding: 24px;
}

.hover-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>

<script>
import {
  roleList,
  roleDelete,
  listDuplicate,
  addRole,
  updateRole,
  listRoleMenu,
  saveRoleMenu,
  addEmployeeRole,
  listPageEmployeeByRoleId,
  delEmployeeRole,
} from "@/api/role";
import AddPeople from "@/components/AddPeople/index.vue";
import Pagination from "@/components/PaginationStyle1.vue";

export default {
  components: { Pagination, AddPeople },
  data() {
    return {
      //左侧 角色列表
      showRightDiv: false,
      //数据
      roleListDefault: [],
      roleListNoDefault: [],

      isIconVisibleDefault: [],
      isIconVisibleNoDefault: [],

      //删除弹窗
      delInfoDialogVisibleFlag: false,
      delInfo: {},

      //新增角色弹窗
      addRoleDialogVisibleFlag: false,
      addRoleForm: {
        roleName: "",
      },

      //菜单默认选中
      menuDefaultActive: "0",
      //左侧选中 角色
      leftMenuCheckRole: null,
      leftMenuCheckRoleChangeFlag: false,
      //临时变量 修改名字后 一致 则不修改
      leftMenuCheckRoleNameTemp: null,
      //显示状态
      rightRoleFocusStatus: false,
      //0 加载中 1加载成功
      rightRoleFocusIconStatus: 0,

      //新增成员
      dialogTitle: "",
      addPeopleVisible: false,
      selectPeopleList: [],

      permissionSettingsDialogVisibleFlag: false,
      //权限数据
      listRoleMenu: {},
      //选中节点
      treeSelectedCount: 0,
      //只看已选  ,  使用临时数组 先获取所有 勾选的节点，然后通过 tree.filter 方法过滤所有节点
      treeShowChecked: false,
      //只看已选 使用 临时数组
      checkedNodeTemp: [],
      defaultProps: {
        children: "childrenList",
        label: "name",
      },

      //右侧列表数据
      //查询
      listLoading: false,
      dataList: [],
      total: 0,
      queryForm: {
        roleId: 0,
        size: 10,
        current: 1,
      },

      queryEmployeeIDORNameForm: {
        keyWord: "",
      },
    };
  },
  methods: {
    showIcon(index, menuIndex) {
      switch (menuIndex) {
        case 1:
          break;
        case 2:
          this.$set(this.isIconVisibleNoDefault, index, true);
          break;
        default:
          break;
      }
    },
    hideIcon(index, menuIndex) {
      switch (menuIndex) {
        case 1:
          break;
        case 2:
          this.$set(this.isIconVisibleNoDefault, index, false);
          break;
        default:
          break;
      }
    },

    async roleList() {
      let params = { current: 1, size: 100 };
      const res = await roleList(params);
      this.roleListDefault = res.data.data.default;
      this.roleListNoDefault = res.data.data.noDefault;

      this.isIconVisibleDefault = this.roleListDefault.map(() => false);
      this.isIconVisibleNoDefault = this.roleListNoDefault.map(() => false);

      //默认选中第一个
      if (this.roleListDefault.length > 0) {
        this.menuDefaultActive = "10";
        await this.leftMenuCheck(this.roleListDefault[0], false);
      }
    },
    delRole(obj) {
      this.delInfoDialogVisibleFlag = true;
      this.delInfo = obj;
    },
    //删除角色
    async delInfoSubmit() {
      let req = { roleId: this.delInfo.id, current: 1, size: 100 };
      const result = await roleDelete(req);
      if (result.data.code === 200) {
        this.$message({ message: "删除成功", type: "success" });
        this.roleList();

        this.leftMenuCheckRole = {};

        //关闭弹窗
        this.delInfoDialogVisibleFlag = false;
      } else {
        this.$message.error(result.data.message);
      }
    },
    addRole() {
      this.addRoleDialogVisibleFlag = true;
    },
    async addRoleSubmitForm() {
      let req = { roleName: this.addRoleForm.roleName, current: 1, size: 100 };
      const result = await addRole(req);
      if (result.data.code === 200) {
        this.$message({ message: "添加成功", type: "success" });
        this.roleList();

        this.cancelDialog();
      } else {
        this.$message.error(result.data.message);
      }
    },
    cancelDialog() {
      this.addRoleDialogVisibleFlag = false;
      this.$refs["addRoleForm"].resetFields();
    },
    async roleBlueEvent() {
      if (this.addRoleForm.roleName === "") {
        this.$message.error("请输入角色名称");
      } else {
        //请求
        let req = {
          roleName: this.addRoleForm.roleName,
          current: 1,
          size: 100,
        };

        const result = await listDuplicate(req);
        if (result.data.code === 200) {
          this.$message({ message: "角色名可以使用", type: "success" });
        } else {
          this.$message.error(result.data.message);
        }
      }
    },
    //左侧菜单 选中一个角色
    async leftMenuCheck(obj, change) {
      //赋值
      this.leftMenuCheckRole = obj;
      this.leftMenuCheckRoleChangeFlag = change;
      this.leftMenuCheckRoleNameTemp = obj.name;

      await this.requestRightList();
    },
    async requestRightList() {
      this.listLoading = true;
      //请求
      this.queryForm.employeeName = null;
      this.queryForm.number = null;
      this.queryForm.roleId = this.leftMenuCheckRole.id;

      //请求接口 右侧列表接口
      const result = await listPageEmployeeByRoleId(this.queryForm);
      if (result.data.code === 200) {
        const list = result.data.data.records;
        this.dataList = [...list];
        this.total = result.data.data.total;
        // console.log(this.dataList)
        this.listLoading = false;

        this.selectPeopleList = [...this.dataList];
        this.selectPeopleList.forEach((value, index) => {
          value.id = value.employeeId;
          value.name = value.employeeName;
        });
        // console.log(">")
        // console.log(this.selectPeopleList)
      } else {
      }
    },

    //获取查询数据
    async getAccountManageMore() {
      this.listLoading = true;
      const res = await listPageEmployeeByRoleId(this.queryForm);
      const list = res.data.data.records;
      this.dataList = [...list];
      this.total = res.data.data.total;
      this.listLoading = false;
    },

    async delEmployeeRole(value) {
      let req = { erId: value.erId, current: 1, size: 100 };
      // console.log(req)
      const result = await delEmployeeRole(req);
      if (result.data.code === 200) {
        this.$message({ message: "删除成功", type: "success" });

        await this.getAccountManageMore();
      } else {
        this.$message.error(result.data.message);
      }
    },

    //右侧 直接修改名称  失去焦点 修改名称
    async rightRoleFocusOutEvent() {
      if (this.leftMenuCheckRole.name === "") {
        this.$message.error("请输入角色名称");
      } else {
        if (this.leftMenuCheckRole.name === this.leftMenuCheckRoleNameTemp) {
          return;
        }

        //请求
        this.rightRoleFocusStatus = true;
        this.rightRoleFocusIconStatus = 0;
        let req = {
          roleId: this.leftMenuCheckRole.id,
          roleName: this.leftMenuCheckRole.name,
          current: 1,
          size: 100,
        };

        const result = await updateRole(req);
        if (result.data.code === 200) {
          this.$message({ message: "修改成功", type: "success" });
          this.rightRoleFocusIconStatus = 1;
          setTimeout(() => {
            this.rightRoleFocusStatus = false;
            this.rightRoleFocusIconStatus = 0;
          }, 3000);
        } else {
          this.$message.error(result.data.message);
        }
      }
    },
    addPeople() {
      this.addPeopleVisible = true;
      this.dialogTitle = "选择人员-分配角色";

      // console.log(this.selectPeopleList)
    },
    closeAddPeople() {
      this.addPeopleVisible = false;
    },
    async submitPeople(employeeRoleList) {
      this.addPeopleVisible = false;

      this.selectPeopleList = employeeRoleList;
      // console.log(this.selectPeopleList);

      let reqEmployeeIds = "";

      employeeRoleList.forEach((value, index) => {
        reqEmployeeIds += value.id + ",";
      });

      let req = {
        roleId: this.leftMenuCheckRole.id,
        employeeIds: reqEmployeeIds,
        current: 1,
        size: 100,
      };
      const result = await addEmployeeRole(req);
      if (result.data.code === 200) {
        this.$message({ message: "添加成功", type: "success" });

        this.requestRightList();
      } else {
        this.$message.error(result.data.message);
      }
    },

    //权限设置
    openPermissionSettings() {
      this.treeShowChecked = false;
      this.permissionSettingsDialogVisibleFlag = true;
      this.checkedNodeTemp = [];
      this.treeSelectedCount = 0;
      this.getListRoleMenu();
    },
    async getListRoleMenu() {
      // console.log(this.permissionSettingsInfo)
      this.leftMenuCheckRole.current = 1;
      this.leftMenuCheckRole.size = 100;
      this.leftMenuCheckRole.roleId = this.leftMenuCheckRole.id;
      // console.log(this.leftMenuCheckRole)
      const res = await listRoleMenu(this.leftMenuCheckRole);
      if (res.data.code === 200) {
        this.listRoleMenu = res.data.data;

        // console.log(this.listRoleMenu)

        this.findChildNodeAndCheck();
      } else {
        this.$message.error(res.data.message);
      }
    },
    //遍历所有 父节点 、叶子节点  同时勾选
    findChildNodeAndCheck() {
      this.listRoleMenu.forEach((value, index) => {
        //遍历所有 叶子节点
        let allLeafNodes = this.realFindChild(value);

        //所有勾选的节点（叶子节点）
        let checkNodeList = [];
        allLeafNodes.forEach((value, index) => {
          //0选中  1未选
          if (value.menuStatus === 0) {
            checkNodeList.push(value);
          }
        });
        //组件 设置勾选
        this.$nextTick(() => {
          this.$refs.tree[index].setCheckedNodes(checkNodeList);
        });
        this.$nextTick(() => {
          this.getTreeNodeCount();
        });
      });
    },

    realFindChild(listNode) {
      return this.traverseAndFindLeafNodes(listNode.menuList);
    },
    traverseAndFindLeafNodes(menuList) {
      let leafNodes = [];

      function traverse(nodes) {
        nodes.forEach((node) => {
          // 如果当前节点的childrenList为空，则它是一个叶子节点
          if (node.childrenList.length === 0) {
            leafNodes.push(node);
          } else {
            // 否则，递归遍历其子节点
            traverse(node.childrenList);
          }
        });
      }

      traverse(menuList);
      return leafNodes;
    },
    //只看已选 状态改变
    showTreeNodeChange(value) {
      //先获取 勾选节点， 再通过 tree.filter方法 过滤所有节点
      this.checkedNodeTemp = [];
      this.listRoleMenu.forEach((value, index) => {
        this.$refs.tree[index]
          .getCheckedNodes(true, true)
          .forEach((value1, index) => {
            this.checkedNodeTemp.push(value1);
          });
      });
      this.listRoleMenu.forEach((value, index) => {
        this.$refs.tree[index].filter(value);
      });
    },
    //过滤节点
    filterNode(value, data) {
      if (this.treeShowChecked) {
        //只看已选
        return this.checkedNodeTemp.includes(data);
      } else {
        return true;
      }
    },
    //选中后改变已选数量
    handleNodeClick(data, checked, indeterminate) {
      //传递给 data 属性的数组中该节点所对应的对象   、  节点本身是否被选中 、 节点的子树中是否有被选中的节点
      // console.log(data, checked, indeterminate);
      this.getTreeNodeCount();
    },
    //获取所有选中节点
    getTreeNodeCount() {
      this.treeSelectedCount = 0;
      this.listRoleMenu.forEach((value, index) => {
        this.treeSelectedCount += this.$refs.tree[index].getCheckedNodes(
          true,
          true
        ).length;
      });
    },
    //修改权限
    async saveRoleMenu() {
      var menuIdsStr = "";
      //获取 所有勾选的节点，  叶子节点+半选节点
      this.listRoleMenu.forEach((value, index) => {
        //1. 是否只是叶子节点，默认值为 false 2. 是否包含半选节点，默认值为 false
        // console.log(this.$refs.tree[index].getCheckedNodes(false, true));
        this.$refs.tree[index]
          .getCheckedNodes(false, true)
          .forEach((value, index) => {
            menuIdsStr += value.menuId + ",";
          });
      });

      let req = {
        menuIds: menuIdsStr,
        roleId: this.leftMenuCheckRole.id,
        size: 0,
        current: 0,
      };

      // console.log(req)
      //请求
      const result = await saveRoleMenu(req);
      if (result.data.code === 200) {
        this.permissionSettingsDialogVisibleFlag = false;
        this.$message({ message: "修改成功", type: "success" });
      } else {
        this.$message.error(result.data.message);
      }
    },

    async queryEmployeeIDORName() {
      this.listLoading = true;
      this.dataList = null;

      //根据关键字查询
      this.queryForm.size = 10;
      this.queryForm.current = 1;
      this.queryForm.employeeName = this.queryEmployeeIDORNameForm.keyWord;
      this.queryForm.number = this.queryEmployeeIDORNameForm.keyWord;

      // console.log(this.queryForm)
      const result = await listPageEmployeeByRoleId(this.queryForm);
      if (result.data.code === 200) {
        const list = result.data.data.records;
        this.dataList = [...list];
        this.total = result.data.data.total;
        // console.log(this.dataList)
        this.listLoading = false;
      } else {
      }
    },
    roleMenuReset() {
      this.findChildNodeAndCheck();
    },
  },
  created() {
    this.roleList();
  },
};
</script>
